import { Route, Routes } from 'react-router-dom';
import { E2nApiApolloProvider } from './lib/ApolloClient';
import { E2nApiAuthProvider } from './lib/E2nApiAuthContext';
import type { E2nApiAuthContextValue } from './lib/E2nApiAuthContext';
import { E2nApiOverviewPage } from './pages/E2nApiOverviewPage';

export type E2nApiProps = E2nApiAuthContextValue;

export function E2nApi(props: E2nApiProps) {
  return (
    <E2nApiAuthProvider value={props}>
      <E2nApiApolloProvider>
        <Routes>
          <Route index element={<E2nApiOverviewPage />} />
        </Routes>
      </E2nApiApolloProvider>
    </E2nApiAuthProvider>
  );
}
